import { useMutation } from 'react-query';
import { BASE_API_URL } from '@env';

export function useSetPassword() {
  return useMutation(async ({ email, new_password }: { email: string; new_password: string }) => {
    const response = await fetch(`${BASE_API_URL}users/auth/set-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
      body: JSON.stringify({ email, new_password }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to set password');
    }
    
    return response.json();
  });
}
